import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../_actions";
import { userConstants } from "../_constants";
import "../assets/css/loginAdmin.css";
import logo from "../assets/images/logopwa.png";

class LoginAdmin_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cell_phone: null,
      password: null,
    };
  }

  getNoavaranShortcut = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/sub_admin/hospital/application_links`,
          null,
          false,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        const noavaranLink = res.data.find(
          ({ name }) => name === "نـوآوران سلامت گستـر شـریف (دانش بنیان)"
        );
        if (noavaranLink === undefined) {
          this.postNoavaranShortcut();
        } else {
          localStorage.setItem(
            "hospital_id",
            JSON.stringify(noavaranLink.hospital_id)
          );
          this.props.history.push("/mainAdmin");
        }
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  postNoavaranShortcut = () => {
    const data = {
      name: "نـوآوران سلامت گستـر شـریف (دانش بنیان)",
      url: "https://noavaran-sharif.ir/",
      image:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAV1BMVEUVUIVFdJ2qv9QmXY2Oq8V+nrxRfaQwZJPd5u64ytrW4eqets2Xsclhia05apjM2eW/z96wxNZzlrbs8fWHpMBZg6iIl6NOdpr4+fuUoategaBCZ4chSGjw/H8wAAAA4klEQVQ4y+2S2RLCIAxFC0nZytbV9f+/U1Fa0trRZ0cznU4SDuQmUP3tW4zZVrcoP3JoUPgRTf2GEV3tuIKH73t0dcd2sagtcjOHUnG0Or6i47Hb2V0fxSYDiu3LUbDZ2s5NXy4HuqA3Xdkhc2eAMz0ccQ22OoN3SFIw8nVlNWat7A7LSspFpEEquV8kH9LHTpNf2uwdUVx84YSrxDSxkgkFpDNoImxaMMUNnsi16UeGIgM5pSFg8nEoCU4WpSnvauBprEtpaFZ3A6fIs4VUtQtzqPn6Dq/Asj3l+jmE6m8/ZzcoMQaf6gECyAAAAABJRU5ErkJggg==",
    };

    this.props
      .dispatch(
        userActions.API(
          "post",
          `v1/sub_admin/hospital/application_links`,
          data,
          false,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        localStorage.setItem(
          "hospital_id",
          JSON.stringify(res.data.hospital_id)
        );
        this.props.history.push("/mainAdmin");
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { getNoavaranShortcut } = this;
    const { cell_phone, password } = this.state;

    if (!cell_phone)
      return userActions.failure(userConstants.ERRORS["username"]);
    if (!password) return userActions.failure(userConstants.ERRORS["password"]);

    const data = {
      cell_phone,
      password,
    };

    this.props
      .dispatch(userActions.API("post", `v1/admin/signin`, data, true, false))
      .then((res) => {
        localStorage.setItem("tokenAdmin", JSON.stringify(res.data.token));

        getNoavaranShortcut();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  render() {
    return (
      <Container>
        <Logo />
        <Title />
        <Form
          onSubmit={this.handleSubmit}
          onName={(e) => this.setState({ cell_phone: e.target.value })}
          onPassword={(e) => this.setState({ password: e.target.value })}
        />
      </Container>
    );
  }
}

class Container extends Component {
  render() {
    return (
      <div className="login-admin">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="form-section">{this.props.children}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class Form extends Component {
  render() {
    const { onSubmit, onName, onPassword } = this.props;

    return (
      <form>
        <div className="form-group clearfix">
          <input
            name="name"
            type="text"
            className="form-control"
            placeholder="نام کاربری"
            aria-label="Full Name"
            onChange={onName}
          />
        </div>
        <div className="form-group clearfix">
          <input
            name="password"
            type="password"
            className="form-control"
            autoComplete="off"
            placeholder="رمز عبور"
            aria-label="Password"
            onChange={onPassword}
          />
        </div>
        <div className="form-group mb-0 clearfix">
          <button
            type="submit"
            className="btn btn-lg btn-primary btn-theme"
            style={{ borderRadius: "50px" }}
            onClick={onSubmit}
          >
            ورود
          </button>
        </div>
      </form>
    );
  }
}

class Title extends Component {
  render() {
    return (
      <div className="main-title">
        <h3 className="headline">
          <span>ورود به </span>
          <span className="words-wrapper">
            <b className="visible">مدیر بیمارستان</b>
          </span>
        </h3>
      </div>
    );
  }
}

class Logo extends Component {
  render() {
    return (
      <div className="logo-2">
        <img src={logo} style={{ width: "110px", height: "85px" }} alt="logo" />
      </div>
    );
  }
}

const LoginAdmin = connect((state) => ({
  globalStorage: state.globalStorage,
}))(LoginAdmin_);

export { LoginAdmin };
